import { render } from "./AboutSection.vue?vue&type=template&id=7b1c7020&scoped=true"
const script = {}

import "./AboutSection.vue?vue&type=style&index=0&id=7b1c7020&lang=postcss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b1c7020"]])

export default __exports__